import moment from 'moment';
import { ensureTrailingSlash } from '../url/url';
import { NoAuthRest } from '../rest/rest';

export const calculateDurationSeconds = (startTimeStr, endTimeStr) => {
  if (startTimeStr == null || endTimeStr == null) {
    return null;
  }
  const startTime = moment(startTimeStr, 'HH:mm');
  if (startTime.isValid() === false) {
    return null;
  }

  const endTime = moment(endTimeStr, 'HH:mm');
  if (endTime.isValid() === false) {
    return null;
  }

  const diff = endTime.diff(startTime) / 1000;
  if (diff < 0) {
    return null;
  }
  return diff;
};

export const createEditableSession = (session) => {
  const dateStr = moment(session.dateTime).format('YYYY-MM-DD');
  const startTimeStr = moment(session.dateTime).format('HH:mm');
  const endTimeStr = moment(session.dateTime)
    .add(session.estimatedDurationSeconds, 'seconds')
    .format('HH:mm');
  const editableSession = {
    ...session,
    dateStr,
    startTimeStr,
    endTimeStr,
  };

  return editableSession;
};

export const checkSessionStatus = async (sessionId) => {
  const apiUrl = ensureTrailingSlash(process.env.REACT_APP_API_URL);
  const joinSessionPath = `${apiUrl}api/v1/session/check/${sessionId}`;
  const result = await NoAuthRest.get(joinSessionPath);
  return result.data;
};

export const fetchJoinSessionData = async (username, sessionId) => {
  const apiUrl = ensureTrailingSlash(process.env.REACT_APP_API_URL);
  const joinSessionPath = `${apiUrl}api/v1/session/join/${username}/${sessionId}`;
  const result = await NoAuthRest.get(joinSessionPath);
  return result.data;
};

export const updateParticipantSubscriptions = async (username, sessionId) => {
  const apiUrl = ensureTrailingSlash(process.env.REACT_APP_API_URL);
  const subsriptionsPath = `${apiUrl}api/v1/session/subscriptions/${username}/${sessionId}`;
  const result = await NoAuthRest.put(subsriptionsPath);
  return result.data;
};
